import React, { useState } from "react";
import { Button, Modal, Popconfirm, Avatar, Badge, Tooltip } from "antd";
import { FieldTimeOutlined } from "@ant-design/icons";
import { openNotificationWithIcon } from "../../../Helper";
import { protectedPostData } from "../../../api/Interface";
import { PublicAPIRoutes } from "../../../api/APIRoutes";

function ServerSelect() {
  const preferredURL = localStorage.getItem("preferredURL");
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedURL, setSelectedURL] = useState(preferredURL);
  const [urls, setUrls] = useState([
    {
      url: "https://api.isoogh.ir/api",
      label: "کلاستر آسیاتک - تهران",
      disable: false,
      loading: false,
      ping: null,
    },
    {
      url: "https://api-c15.isoogh.ir/api",
      label: "کلاستر سینداد - تهران",
      disable: false,
      loading: false,
      ping: null,
    },
    {
      url: "https://api-c13.isoogh.ir/api",
      label: "کلاستر پارس آنلاین - پونک",
      disable: false,
      loading: false,
      ping: null,
    },
  ]);

  const handleURLSelection = (url, disable) => {
    if (!disable) {
      setSelectedURL(url);
    } else {
      openNotificationWithIcon(
        "error",
        `کلاستر با خطا مواجه شده است`,
        "لطفا کلاستر دیگری را امتحان کنید"
      );
    }
  };

  const handlePopconfirmConfirm = (item) => {
    if (localStorage.getItem("preferredURL") === item.url) {
      openNotificationWithIcon("info", `شما به ${item.label} متصل هستید `);
    } else if (
      !localStorage.getItem("preferredURL") &&
      item.url === "https://api.isoogh.ir/api"
    ) {
      openNotificationWithIcon("info", `شما به ${item.label} متصل هستید `);
    } else {
      localStorage.setItem("preferredURL", selectedURL);
      openNotificationWithIcon(
        "success",
        `سرور به ${item.label} تغییر کرد`,
        "لطفا تا ثبت کامل تنظیمات صبر کنید"
      );
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const calculatePing = async () => {
    setLoading(true);
    try {
      const updatedUrls = urls.map((url) => ({ ...url, loading: true }));
      setUrls(updatedUrls);

      const pings = await Promise.all(
        updatedUrls.map(async (item) => {
          const startTime = Date.now();
          const data = { role: 0 };
          const res = await protectedPostData(
            `${item.url}/v2/faqs/get-faqs`,
            data
          );
          if (res) {
            const endTime = Date.now();
            const ping = endTime - startTime;
            const updatedItem = {
              ...item,
              loading: false,
              ping: ping,
            };
            setUrls((prevUrls) =>
              prevUrls.map((prevUrl) =>
                prevUrl.label === item.label ? updatedItem : prevUrl
              )
            );
            return { label: item.label, ping: ping };
          } else {
            const updatedItem = {
              ...item,
              loading: false,
              disable: true,
              ping: undefined,
            };
            setUrls((prevUrls) =>
              prevUrls.map((prevUrl) =>
                prevUrl.label === item.label ? updatedItem : prevUrl
              )
            );
          }
        })
      );

      setUrls((prevUrls) =>
        prevUrls.map((item) => {
          const ping = pings.find((p) => p?.label === item?.label)?.ping;
          return { ...item, ping };
        })
      );
    } catch (error) {
      console.log(error);
      openNotificationWithIcon(
        "error",
        "خطا در محاسبه پینگ",
        "لطفا دوباره تلاش کنید"
      );
    } finally {
      setLoading(false);
    }
  };

  const modalHandler = () => {
    calculatePing();
    setIsModalVisible(true);
  };

  const modalContent = (
    <div className="d-flex flex-wrap justify-content-center align-items-center">
      <div className="text-warning">در صورت افت سرعت سرویس خود را عوض کنید</div>
      <Button
        className="mx-2 col-10 col-md-4"
        size="medium"
        type="primary"
        icon={<FieldTimeOutlined />}
        loading={loading}
        onClick={calculatePing}
      >
        <span className="mx-2">نمایش پینگ</span>
      </Button>
      <div className="col-12 mt-3">
        {urls.map((item) => (
          <div className="d-flex col-12" key={item.label}>
            <Popconfirm
              style={{ zIndex: "1000000 !important" }}
              title={`سرور به ${item.label} تغییر کند؟`}
              okText="تغییر سرور"
              cancelText="انصراف"
              onConfirm={() => handlePopconfirmConfirm(item)}
              disabled={item.loading || item.disable}
            >
              <Button
                className="d-flex justify-content-start align-items-center selectServerBtn"
                onClick={() => handleURLSelection(item.url, item.disable)}
                key={item.url}
                value={item.url}
                style={{ cursor: item.disable && "not-allowed" }}
              >
                {localStorage.getItem("preferredURL") === item.url ? (
                  <div className="d-flex align-items-center">
                    <Avatar
                      className="flashing-badge"
                      shape="circle"
                      style={{ backgroundColor: "#fff", color: "#52c41a" }}
                      icon={<i className="fa-solid fa-wifi mx-1"></i>}
                    />
                    <div className="mx-1" style={{ color: "green" }}>
                      {item.label}
                    </div>
                  </div>
                ) : !localStorage.getItem("preferredURL") &&
                  item.url === "https://api.isoogh.ir/api" ? (
                  <div className="d-flex align-items-center">
                    <Avatar
                      className="flashing-badge"
                      shape="circle"
                      style={{ backgroundColor: "#fff", color: "#52c41a" }}
                      icon={<i className="fa-solid fa-wifi mx-1"></i>}
                    />
                    <div className="mx-1" style={{ color: "green" }}>
                      {item.label}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <Avatar
                      shape="circle"
                      style={{ backgroundColor: "#fff", color: "#3c3c3c" }}
                      icon={<i className="fa-solid fa-wifi mx-1"></i>}
                    />
                    <div className="mx-1">{item.label}</div>
                  </div>
                )}
                {item.loading ? (
                  <Badge
                    className="mx-1"
                    count={"در حال محاسبه پینگ"}
                    style={{ backgroundColor: "orange" }}
                  />
                ) : item.ping !== undefined ? (
                  <Badge
                    className="mx-1"
                    count={`${item.ping} ms`}
                    style={{ backgroundColor: "#52c41a" }}
                  />
                ) : (
                  <Badge
                    className="mx-1"
                    count={"خطا در محاسبه پینگ"}
                    style={{ backgroundColor: "red" }}
                  />
                )}
              </Button>
            </Popconfirm>
          </div>
        ))}
        <div className="d-flex col-12">
          <Button
            className="d-flex justify-content-start align-items-center selectServerBtn"
            disabled
          >
            <Avatar
              shape="circle"
              style={{ backgroundColor: "#f5f5f5", color: "#3c3c3c" }}
              icon={<i className="fa-solid fa-wifi mx-1"></i>}
            />
            <div className="mx-1">کلاستر بامداد - تهران</div>
            <Badge
              className="mx-1"
              count="به زودی"
              style={{ backgroundColor: "#3c3c3c" }}
            />
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="App">
      <Tooltip
        placement="bottomLeft"
        color="lime"
        title={
          preferredURL
            ? urls.map(
                (cluster) => cluster.url === selectedURL && cluster.label
              )
            : "کلاستر آسیاتک - تهران"
        }
      >
        <button
          className="d-flex align-items-center bell-pannel-btn"
          shape="round"
          icon={null}
          onClick={modalHandler}
          size={90}
        >
          <i className="fa-solid fa-satellite-dish fa-lg"></i>
        </button>
      </Tooltip>
      <Modal
        title="انتخاب کلاستر"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        className="selectServerModal"
      >
        {modalContent}
      </Modal>
    </div>
  );
}

export default ServerSelect;
